<template>
    <div class="row d-flex align-items-end wrapper mt-5 pb-3">
        <div class="col-12 col-sm-4 d-none d-sm-block">
            <img :src="kotoriImg" class="img-fluid rounded"/>
        </div>
        <div class="col-12 col-sm-8 align-self-center">
            <div class="row justify-content-center">
                <div class="col-4">
                    <img :src="kotoriImg" class="kotori img-fluid rounded col-4 d-block d-sm-none d-md-none d-lg-none"/>
                </div>
                <h2 class="mt-2 mb-4 mb-sm-3 mt-sm-3 mb-lg-4 text-kotori col col-sm-12 text-center align-self-center">API</h2>
            </div>
            <div class="row justify-content-center form-pc">
                <ul>
                    <li>{{ $t('method') }}GET/POST</li>
                    <li>{{ $t('address') }}<a :href="apiUrl">{{ apiUrl }}</a> </li>
                    <li>{{ $t('parameters') }}<br>
                        <ul>
                            <li>{{ $t('url') }}</li>
                            <li>{{ $t('title') }}</li>
                            <li>{{ $t('format') }}</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<i18n>
en:
  method: "Method: "
  address: "Address: "
  parameters: "Parameters: "
  url: "url: The URL to be shortened"
  title: "title(optional): Customize title"
  format: "format(optional): Response format [json jsonp xml simple]"
zh:
  method: "请求方法："
  address: "请求地址："
  parameters: "请求参数："
  url: "url: 要压缩的网址"
  title: "title(可选): 自定义标题"
  format: "format(可选): 响应格式 [json jsonp xml simple]"
</i18n>

<script>
    import config from "./config";

    export default {
        data() {
            return {
                kotoriImg: require('./lina.jpg'),
                selectCooldown: false,
                apiUrl: config.url
            }

        },
    }
</script>

<style scoped>

    a {
        color: #5287a7;
    }

    ul {
        font-family: monospace;
    }

    .kotori {
        min-width: 146px;
    }

    .wrapper {
        border-style: dotted;
        border-width: 0.3em;
        -webkit-border-radius: 1em;
        -moz-border-radius: 1em;
        border-radius: 1em;
        border-color: #5287a7;

    }

    .btn-kawaii {
        background-color: #5287a7;
    }

    .text-kotori {
        color: #f07eba;
        -webkit-transition: font-size 0.5s;
        -moz-transition: font-size 0.5s;
        -ms-transition: font-size 0.5s;
        -o-transition: font-size 0.5s;
        transition: font-size 0.5s;
    }

    @media screen and (min-width: 1200px) {
        .text-kotori {
            font-size: 5em;
        }
        ul {
            font-size: 20px;
        }
    }

    @media screen and (min-width: 992px) and (max-width: 1200px) {
        .text-kotori {
            font-size: 4em;
        }
        ul {
            font-size: 18px;
        }
    }

    @media screen and (min-width: 768px) and (max-width: 992px) {
        .text-kotori {
            font-size: 3em;
        }
        ul {
            font-size: 16px;
        }
    }

    @media screen and (min-width: 576px) and (max-width: 768px) {
        .text-kotori {
            font-size: 2em;
        }
        ul {
            font-size: 14px;
        }
    }

    @media screen and (max-width: 576px) {
        .text-kotori {
            font-size: 1.5em;
        }
        .form-pc {
            margin: 1rem 0.1rem;
        }
        .form-pc button {
            margin-top: 0.2rem;
        }
        .pb-3 {
            padding-bottom: 0!important;
        }
        ul {
            font-size: 14px;
        }
    }

    .url-input {
        /*margin: 0.3em 0.2em 0 0;*/
    }
</style>



// WEBPACK FOOTER //
// api.vue?666bacd8